<template>
  <analytics-sub-page
    title="Impact"
    icon="chart-line"
    css-class="analytics-benchmark"
    default-label="Impact"
    :show-divisions-dropdown="false"
    :section-specs="sectionSpecs"
  >
    <page-sub-header title="Stream Impact" class="mb-3" />
    <dashboard-impact ref="dashboardImpactRef" class="mb-4" />
    <workforce-impact-section ref="workforceImpactRef" :metrics="metrics" :sector="sector" :loading="loading" />
  </analytics-sub-page>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import ApiClient from '@/ApiClient';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import PageSubHeader from '@/components/PageSubHeader.vue';
import DashboardImpact from '@/pages/analyticsBenchmark/components/DashboardImpact.vue';
import WorkforceImpactSection from '@/pages/analyticsBenchmark/components/WorkforceImpactSection.vue';

const loading = ref(true);
const sector = ref(null);
const metrics = ref([]);
const dashboardImpactRef = ref(null);
const workforceImpactRef = ref(null);

const fetchData = async () => {
  loading.value = true;
  try {
    const data = await ApiClient.getSectorBenchmarks();
    sector.value = data?.sector || null;
    metrics.value = data?.metrics || [];
  } catch (error) {
    console.error('Failed to fetch sector benchmarks:', error);
  }
  loading.value = false;
};

onBeforeMount(() => fetchData());

const sectionSpecs = [
  { key: 'stream-impact', label: 'Stream Impact', ref: dashboardImpactRef },
  { key: 'workforce-impact', label: 'Workforce Impact', ref: workforceImpactRef },
];
</script>
